var $f80715c2c0b326b4$exports = {};
$f80715c2c0b326b4$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$f80715c2c0b326b4$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
